import { SplitButtonDesignTokens } from '@primeuix/themes/types/splitbutton';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/splitbutton/index.ts
const spb = componentCommon.splitbutton;

export const SplitbuttonTelekomDT: SplitButtonDesignTokens = {
  root: {
    borderRadius: t(spb.border.radius),
    roundedBorderRadius: t(spb.rounded.border.radius),
  },
};
